import React from 'react';
import Body from "./common/Body";
import {Route, Routes, useLocation} from "react-router-dom";
import Page from "./common/Page";
import HomepageIndex from "./pages/HomepageIndex";
import AccountIndex from "./pages/AccountIndex";
import AdminIndex from "./pages/AdminIndex";

import {AuthProvider} from "../context/AuthContext";
import {useSelector} from "react-redux";
import LeaderboardIndex from "./pages/leaderboard/LeaderboardIndex";

const Routing = () => {

    const location = useLocation();
    const user = useSelector(({UserReducer}) => UserReducer.user);

    return (
        <AuthProvider>
            <Body>
                <Routes location={location}>
                    <Route exact path="/" element={<Page title={"Home"}><HomepageIndex /></Page>}/>
                    <Route exact path="/leaderboard" element={<Page title={"Home"}><LeaderboardIndex /></Page>}/>
                    <Route exact path="/account/*" element={<Page title={"Account"}><AccountIndex /></Page>}/>
                    {user?.isAdmin && (
                        <Route exact path="/admin/*" element={<Page title={"Admin"}><AdminIndex /></Page>}/>)}
                </Routes>
            </Body>
        </AuthProvider>);
}

export default Routing;
